import Vue from 'vue';
import dayjs from 'dayjs';

const dateOnly = value => (value ? dayjs(value).format('DD/MM/YY') : '');

Vue.filter('dateOnly', dateOnly);
